<template>
  <apexchart
    type="donut"
    :height="height"
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>
<script>
export default {
  name: "ComplianceBarChart",
  props: {
    fees: [],
    labels: [],
    isNAvalue: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: "310"
    },
    currency: {
      type: String,
      default: "EUR"
    },
    position: {
      type: String,
      default: "right"
    }
  },
  data() {
    return {
      colors: [
        "#e55b96",
        "#29D264",
        "#fcc032",
        "#a08fac",
        "#5f57b0",
        "#31ca8f",
        "#c741f1",
        "#0cd2e6",
        "#dd1102",
        "#5C4742",
        "#0000ff",
        "#A5978B",
        "#8D5B4C",
        "#ff7373",
        "#5A2A27",
        "#C4BBAF",
        "#ff80ed",
        "#00ffff",
        "#ffff66",
        "#20b2aa"
      ],
      noDataMsg: "No data for the chosen filters.",
      series: this.fees,
      chartOptions: {
        currency: this.currency,
        chart: {
          type: "donut"
        },
        colors: this.colors,
        stroke: {
          width: this.labels.length > 1 ? 1 : 0
        },
        plotOptions: {
          pie: {
            donut: {
              size: "25%"
            }
          }
        },
        tooltip: {
          y: {
            formatter: function(value, opts) {
              return (
                value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                " " +
                opts.config.currency
              );
            },
            title: {
              formatter: seriesName => {
                return seriesName;
              }
            }
          },
          fixed: {
            enabled: false,
            position: "topRight",
            offsetX: 0,
            offsetY: 0
          }
        },
        noData: {
          text: "No data for the chosen filters.",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0
        },
        labels: this.labels,
        legend: {
          position: this.position
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              }
            }
          }
        ]
      }
    };
  },
  watch: {
    fees(newValue) {
      if (newValue.length > 0 && newValue.reduce((a, b) => a + b, 0) == 0) {
        this.series = [];
        this.noDataMsg = [
          "No fees paid to this scheme",
          "within selected date range."
        ];
      } else {
        this.series = newValue;
        this.noDataMsg = "No data for the chosen filters.";
      }
    },
    isNAvalue(newValue) {
      if (newValue) {
        this.chartOptions = {
          noData: {
            text: "No prices available for selected scheme.",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0
          }
        };
      }
    },
    labels(newValue) {
      this.chartOptions = {
        chart: {
          type: "donut"
        },
        currency: this.currency,
        colors: this.colors,
        stroke: {
          width: this.labels.length > 1 ? 1 : 0
        },
        plotOptions: {
          pie: {
            donut: {
              size: "25%"
            }
          }
        },
        labels: newValue,
        legend: {
          position: this.position
        },
        tooltip: {
          y: {
            formatter: function(value, opts) {
              return (
                value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                " " +
                opts.config.currency
              );
            },
            title: {
              formatter: seriesName => {
                return seriesName;
              }
            }
          }
        },
        noData: {
          text: this.noDataMsg,
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              }
            }
          }
        ]
      };
    }
  }
};
</script>
